var _defs, _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorksetConnectedWithReservations24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#363545;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "WorksetConnectedWithReservations_24") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15,16V14a3,3,0,0,0-6,0v2H8v5h8V16Zm-4-2a1,1,0,0,1,2,0v2H11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.35,7a7.49,7.49,0,0,0-14-2A6,6,0,0,0,6,17V15A4,4,0,0,1,6,7h.71A5.5,5.5,0,0,1,17.5,8.5V9H19a3,3,0,0,1,0,6H18v2h1a5,5,0,0,0,.35-10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorksetConnectedWithReservations24);
export default __webpack_public_path__ + "static/media/WorksetConnectedWithReservations_24.123f1f4dbd473593b69da9fec02b896e.svg";
export { ForwardRef as ReactComponent };